module.exports = __webpack_public_path__ + "img/naja_logo.bb38c29d.png";